import { useContext } from "react";

import { ConsultationContext } from "./ConsultationContext";

export function useConsultation() {
  const context = useContext(ConsultationContext);
  if (context === undefined) {
    throw new Error(
      "useConsultation must be used within a ConsultationProvider",
    );
  }
  return context;
}
